import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logoamarillo.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-0ac8dfee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "nav" }
const _hoisted_3 = { class: "left item-container" }
const _hoisted_4 = { class: "logo-container" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "logo"
  }),
  /*#__PURE__*/_createElementVNode("h1", { class: "logo-text" }, [
    /*#__PURE__*/_createTextVNode("Thot"),
    /*#__PURE__*/_createElementVNode("span", null, "ex")
  ])
], -1))
const _hoisted_6 = {
  key: 0,
  class: "right item-container"
}
const _hoisted_7 = {
  key: 1,
  class: "right item-container"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "button-container" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "login-button" }, "Portal")
], -1))
const _hoisted_9 = { class: "form-container" }

import { Ref, ref } from 'vue';
import RegistrationForm from '@/views/HomePageViews/RegistrationForm.vue';
import LoginForm from '@/views/HomePageViews/LoginForm.vue';
// import { useRouter } from 'vue-router';
import IRouterShownName from '@/interfaces/IRouter';
import { useCookies } from 'vue3-cookies';
import swal from 'sweetalert';
// Auth
import AuthService from '@/services/AuthService';

// const router = useRouter()

export default /*#__PURE__*/_defineComponent({
  __name: 'NavBarHomepage',
  props: {
	navBarRouterNames: {
		type: Array as () => IRouterShownName[],
		},
	},
  setup(__props) {

const { cookies } = useCookies();
const isAuthenticated : Ref<boolean> = ref(cookies.isKey('jwt'))

const showLogin : Ref<boolean> = ref(false);
const showRegister : Ref<boolean> = ref(false);


const successRegister = () => {
	swal("¡Genial!", "Se ha registrado exitosamente", "success");
	closeFormRegister();
};

const props = __props



const toggleRegisterView = () => {
	showRegister.value = !showRegister.value;
	// router.push('/register')
};

const toggleLoginView = () => {
	showLogin.value = !showLogin.value;
	// router.push('/login')
};

const closeFormLogin = () => {
	toggleLoginView()
	// router.push('/')
}

const closeFormRegister = () => {
	toggleRegisterView()
	// router.push('/')
}

const logout = async () => {
	const auth : AuthService = new AuthService();
	if (await auth.logout()) {
		isAuthenticated.value = false
		swal("Se ha cerrado la sesión exitosamente");
	} else {
		console.log("Error al cerrar la sesión")
		console.log(auth.getError)
		swal("Error al cerrar la sesión");
	}
}



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("nav", _hoisted_2, [
        _createElementVNode("ul", _hoisted_3, [
          _createElementVNode("li", _hoisted_4, [
            _createVNode(_component_router_link, { to: {name: 'home'} }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            })
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.navBarRouterNames, (item) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "item",
              key: item.name
            }, [
              _createVNode(_component_router_link, {
                to: {name: item.name}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.shownName), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]))
          }), 128))
        ]),
        (!isAuthenticated.value)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [
              _createElementVNode("li", { class: "button-container" }, [
                _createElementVNode("button", {
                  class: "login-button",
                  onClick: toggleLoginView
                }, "Ingresar")
              ]),
              _createElementVNode("li", { class: "button-container" }, [
                _createElementVNode("button", {
                  class: "register-button",
                  onClick: toggleRegisterView
                }, "Registrarse")
              ])
            ]))
          : (_openBlock(), _createElementBlock("ul", _hoisted_7, [
              _createVNode(_component_router_link, { to: {name: 'portal'} }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              }),
              _createElementVNode("li", { class: "button-container" }, [
                _createElementVNode("button", {
                  class: "register-button",
                  onClick: logout
                }, "Cerrar sesión")
              ])
            ]))
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      (showLogin.value)
        ? (_openBlock(), _createBlock(LoginForm, {
            key: 0,
            class: "modal-form",
            onCloseFormLogin: closeFormLogin
          }))
        : _createCommentVNode("", true),
      (showRegister.value)
        ? (_openBlock(), _createBlock(RegistrationForm, {
            key: 1,
            class: "modal-form",
            onCloseFormRegister: closeFormRegister,
            onSuccessRegister: successRegister
          }))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})